import type { PanchangamFolderConfig } from "../types";

const YODA_CDN_URL = process.env.REACT_APP_NEW_CDN_URL || "https://srm-sbox-cdn.a4b.io";

// Hardcoded folder sources for L1. Add or edit folder URLs here only.
// The cache_bust param is intentionally omitted here — readJsonFromUrl appends
// cache_bust: Date.now() on every call, so CloudFront always gets a unique URL.
export const PANCHANGAM_FOLDER_INFO_URLS: Record<string, string> = {
    panchangam: `${YODA_CDN_URL}/panchangam_panchangam_folder_info.json`,
    shyambaba: `${YODA_CDN_URL}/shyambaba_shyambaba_folder_info.json`,
    srimandir: `${YODA_CDN_URL}/srimandir_srimandir_folder_info.json`,
    internal: `${YODA_CDN_URL}/internal_internal_folder_info.json`,
    kundli: `${YODA_CDN_URL}/kundli_kundli_folder_info.json`,
    dailydarshan: `${YODA_CDN_URL}/dailydarshan_dailydarshan_folder_info.json`
};

export const PANCHANGAM_FOLDERS: PanchangamFolderConfig[] = Object.entries(
    PANCHANGAM_FOLDER_INFO_URLS,
).map(([id, staticInfoUrl]) => ({ id, staticInfoUrl }));
